import React from 'react';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import ChevronDown from 'react-dates/esm/components/ChevronDown';
import { SUBTITLE_COLOR, TYPOGRAPHY_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
    width: '100%',
    height: '30%',
    alignItems: 'center',
    '&:hover': {
      textDecoration: 'none',
    },

    padding: theme.spacing(0.5),
    maxWidth: 480,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
      maxWidth: '100%',
    },
  },
  texts: {
    width: '100%',

    textAlign: 'start',
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    },
  },
  title: {
    fontWeight: 'bold',
    color: TYPOGRAPHY_COLOR,
    fontSize: theme.typography.pxToRem(14),
    fontFamily: 'Montserrat, sans-serif',

    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(1),
    },
  },
  subtitle: {
    color: SUBTITLE_COLOR,
    fontSize: theme.typography.pxToRem(11),
  },
  icon: {
    width: 12,
  },
}));

const TableOfContent = ({ id, title, subtitle }) => {
  const classes = useStyles();
  return (
    <Link classes={{ root: classes.link }} href={`#${id}`} underline="none">
      <div className={classes.texts}>
        <Typography classes={{ root: classes.title }}>{title}</Typography>
        <Typography classes={{ root: classes.subtitle }}>{subtitle}</Typography>
      </div>
      <ChevronDown className={classes.icon} />
    </Link>
  );
};

export default TableOfContent;
